import { Outlet } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { ClientEmployeeTabs } from "@components/Tabs";

import { PortalSubNavigationTabs } from "@layouts/PortalPage/PortalSubNavigationTabs";

import { routes } from "@pages/routes";

export const ClientEmployee = () => {
  const { clientId, clientEmployeeId } = useTypedParams(
    routes.portal.clients.client.clientEmployees.clientEmployee,
  );

  return (
    <>
      <PortalSubNavigationTabs>
        <ClientEmployeeTabs
          clientId={clientId}
          clientEmployeeId={clientEmployeeId}
        />
      </PortalSubNavigationTabs>
      <Outlet />
    </>
  );
};
